import styled from 'styled-components';
import { VIEW_IN_SEGMENTATION } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { FlexSpacer } from 'ui/flexSpacer';
import { Open24 } from 'ui/icons';
import { Body2Medium, colors, spacing } from 'ui/theme';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { SegmentationLinkButton } from 'modules/segmentation/navigation';
import { FC } from 'react';

const MarginlessBody2Medium = styled(Body2Medium)`
  margin: 0;
`;

const SpacingSegmentationLinkButton = styled(SegmentationLinkButton)`
  margin-right: ${spacing.plusHalf};
`;

export const VIEW_IN_SEGMENTATION_ID = 'view-in-segmentation';

export interface ViewSegmentationProps {
  searchQuery: CompleteQuery;
}
export const ViewSegmentation: FC<ViewSegmentationProps> = ({ searchQuery }) => {
  return (
    <SpacingSegmentationLinkButton
      data-test={VIEW_IN_SEGMENTATION_ID}
      searchQuery={searchQuery}
      size={BUTTON_SIZES.LARGE}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      <FlexSpacer alignItems="center">
        <MarginlessBody2Medium>{VIEW_IN_SEGMENTATION}</MarginlessBody2Medium>
        <Open24 color={colors.iconSubtle} />
      </FlexSpacer>
    </SpacingSegmentationLinkButton>
  );
};
